import { render, staticRenderFns } from "./BulkMarkAsReadModal.vue?vue&type=template&id=d6bd9ea4&scoped=true"
import script from "./BulkMarkAsReadModal.vue?vue&type=script&lang=js"
export * from "./BulkMarkAsReadModal.vue?vue&type=script&lang=js"
import style0 from "./BulkMarkAsReadModal.vue?vue&type=style&index=0&id=d6bd9ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bd9ea4",
  null
  
)

export default component.exports